module.exports = __webpack_public_path__ + "img/robot_1.73df578b.png";